@use "src/theme";

// One look for every status: a light tint of the status colour, a matching
// border and icon, and body text in the foreground colour so it meets text
// contrast in both themes.
.callout {
  --callout-color: var(--color-primary);
  --callout-text-color: var(--color-info-text);
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  padding: 0.75rem 0.875rem;
  border: 1px solid color-mix(in srgb, var(--callout-color) 20%, var(--color-border));
  border-radius: var(--radius-md);
  background-color: color-mix(in srgb, var(--callout-color) 5%, var(--color-card));
  color: var(--color-foreground);
  font-size: 0.875rem;
  line-height: 1.5;

  @include theme.notification-content;

  > svg {
    flex: none;
    width: 1rem;
    height: 1rem;
    margin-top: 0.125em;
    // Icons carry meaning, so they need 3:1 against the surface (WCAG 1.4.11).
    color: var(--callout-text-color);
  }

  > .content {
    min-width: 0;
    flex: 1;

    // Paragraphs and other blocks are spaced apart. Only block elements, so inline text, links
    // and chips keep flowing on one line.
    > :where(p, div, ul, ol, dl, h2, h3, h4) + :where(p, div, ul, ol, dl, h2, h3, h4) {
      margin-top: 0.5rem;
    }

    > .title {
      font-weight: 500;

      + * {
        margin-top: 0.125rem;
      }
    }

    > .actions {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
      margin-top: 0.625rem;
    }
  }

  &[data-size="small"] {
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
  }

  &[data-color="success"] {
    --callout-color: var(--color-success);
    --callout-text-color: var(--color-success-text);
  }

  &[data-color="danger"] {
    --callout-color: var(--color-danger);
    --callout-text-color: var(--color-danger-text);
  }

  &[data-color="warning"] {
    --callout-color: var(--color-warning);
    --callout-text-color: var(--color-warning-text);
  }

  &[data-color="info"] {
    --callout-color: var(--color-info);
    --callout-text-color: var(--color-info-text);
  }
}
